import { media } from '../../styles/media';
import styled from 'styled-components';

export const Root = styled.div`
  align-items: center;
  flex-direction: row;
  margin-top: ${props => props.theme.layout.gutter}px;
  display: flex;
  flex-wrap: wrap;
  justify-content: stretch;
`;

export const ControlWrapper = styled.div`
  order: 3;
  width: 33%;
  align-items: center;
  justify-content: center;
  display: flex;

  ${media.tablet`
    width: inherit;
    order: 1;
  `};
`;

export const Wave = styled.div`
  order: 1;
  width: 100%;
  margin: 0 0 10px;
  break-after: always;

  ${media.tablet`
    flex: 1;
    margin: 0 ${props => props.theme.layout.gutter}px;
    order: 4;
  `};
`;

export const TimeWrapper = styled.div`
  order: 5;
  width: 33%;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  display: flex;

  ${media.tablet`
    width: inherit;
    order: 4;
  `};
`;

export const CircularButton = styled.button`
  cursor: pointer;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 1px solid #d9dcde;
  background-color: transparent;
  padding: 6px;
  min-width: auto;

  &:hover {
    border: 1px solid #808b91;
  }
`;

export const ButtonRestart = styled(CircularButton)`
  margin-right: 10px;
`;

export const ButtonBack = styled(CircularButton)`
  margin-right: 10px;
`;
export const ButtonPlayWrapper = styled.div`
  display: flex;
  order: 4;
  flex: 1;
  align-items: center;
  justify-content: center;

  ${media.tablet`
    width: inherit;
    flex: none;
    order: 2;
  `};
`;

export const ButtonPlay = styled.button`
  width: 52px;
  height: 52px;
  cursor: pointer;
  background: #fd6f48;
  border-radius: 70px;
  border: 4px solid rgba(255, 255, 255, 1);

  &:hover {
    border: 4px solid rgba(255, 255, 255, 0.8);
  }
`;

export const Separator = styled.div`
  margin: 0 8px;
  height: 20px;
  width: 1px;
  background-color: ${props => props.theme.color.grey};
`;

export const Time = styled.span`
  font-family: 'Helvetica';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;

  color: #05425e;
`;
